import { motion } from "framer-motion";

const Bubble = ({ x, y, size, delay }) => {
  return (
    <motion.div
      className="absolute rounded-full bg-indigo-400 opacity-20 blur-lg"
      style={{
        width: size,
        height: size,
        left: x,
        top: y,
      }}
      animate={{
        y: [0, -100],
        opacity: [0.2, 0.4, 0.2],
      }}
      transition={{
        duration: 6,
        repeat: Infinity,
        delay,
        ease: "easeInOut",
      }}
    />
  );
};


export default Bubble;